<div
  class="soft-card rounded-[6px] flex w-full abteilungs-center items-center justify-between relative cursor-pointer"
  [ngClass]="
    mode === 'selection' && selected
      ? ' border-solid border-2 border-primary'
      : 'border-solid border-2 border-transparent'
  "
  (click)="tapped.emit()"
>
  <div class="w-full flex items-center flex-row gap-2 z-10">
    @if (abteilungStatusDasharrayData()?.total) {
      @if (abteilungStatusDasharrayData(); as dasharrayData) {
        <soft-donut-chart
          size="w-14 h-14"
          [showTotal]="true"
          [segments]="[
            {
              label: '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ANWESEND',
              value: dasharrayData.anwesend?.number || 0,
              color: 'var(--colorSuccess500)',
            },
            {
              label: '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ABWESEND_ROT',
              value: dasharrayData.abwesendRot?.number || 0,
              color: 'var(--colorDanger500)',
            },
            {
              label: '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ABWESEND_GELB',
              value: dasharrayData.abwesendGelb?.number || 0,
              color: 'var(--colorWarning500)',
            },
          ]"
        ></soft-donut-chart>
        <!--div class="flex flex-col relative">
          <svg class="donut w-14 z-10" viewBox="0 0 42 42">
            <circle
              class="donut-hole"
              fill="var(--colorSurface)"
              cx="21"
              cy="21"
              r="15.91549430918954"
            ></circle>

            <circle
              id="donut-segment2"
              cx="21"
              cy="21"
              r="15.91549430918954"
              stroke="var(--colorSuccess500)"
              stroke-width="4"
              fill="transparent"
              [attr.stroke-dasharray]="dasharrayData.anwesend.dasharray"
              [attr.stroke-dashoffset]="dasharrayData.anwesend.dasharrayOffset"
            ></circle>
            <circle
              id="donut-segment3"
              cx="21"
              cy="21"
              r="15.91549430918954"
              stroke="var(--colorDanger500)"
              stroke-width="4"
              fill="transparent"
              [attr.stroke-dasharray]="dasharrayData.abwesendRot.dasharray"
              [attr.stroke-dashoffset]="dasharrayData.abwesendRot.dasharrayOffset"
            ></circle>
            <circle
              id="donut-segment4"
              cx="21"
              cy="21"
              r="15.91549430918954"
              stroke="var(--colorWarning500)"
              stroke-width="4"
              fill="transparent"
              [attr.stroke-dasharray]="dasharrayData.abwesendGelb.dasharray"
              [attr.stroke-dashoffset]="dasharrayData.abwesendGelb.dasharrayOffset"
            ></circle>
          </svg>

          <div
            class="absolute z-10 text-light font-semibold flex inset-0 text-xs text-center justify-center items-center"
          >
            {{ abteilung().status?.anwesend || 0 }}
          </div>
        </div-->
      }
    } @else {
      <div class="flex items-center justify-center w-14 h-14">
        <soft-loading-spinner></soft-loading-spinner>
      </div>
    }

    <div class="flex flex-grow w-100 m-0 pl-2">
      <div class="flex flex-col abteilungs-start pb-1.5">
        <div class="mt-1.5 font-semibold">{{ abteilung().abteilung.bezeichnung }}</div>
        <div class="mt-1.5 text-sm text-light">
          {{ abteilung().status?.anwesend || 0 }} von
          {{ abteilungStatusDasharrayData()?.total || 0 }}
          {{ '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ANWESEND' | translate }}
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="mode === 'display'">
    <div class="flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5 opacity-25"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.25 4.5l7.5 7.5-7.5 7.5"
        />
      </svg>
    </div>
  </ng-container>

  <ng-container *ngIf="mode === 'selection' && selected">
    <div
      class="bg-surface rounded-full border-solid border-primary border-2 p-1 z-10 flex items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2.5"
        stroke="currentColor"
        class="w-5 h-5 text-primary"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
      </svg>
    </div>
  </ng-container>
</div>
